<template>
  <div class='deferlnvoicing'>
    <div class='nav'>
      <el-form :model='form' label-width='100px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='委托商:'>
          <el-input v-model='form.companyName' size='mini'
                    placeholder='请输入委托商'></el-input>
        </el-form-item>
        <el-form-item label='标题:'>
          <el-input v-model='form.title' size='mini' placeholder='请输入标题'></el-input>
        </el-form-item>
        <el-form-item label='状态:'>
          <el-select v-model='form.status' filterable size='mini' placeholder='全部'>
            <el-option label='全部' value=''></el-option>
            <el-option label='未开票' value='0'></el-option>
            <el-option label='已开票' value='1'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index'
                           :index='tableIndexMethod'>

          </el-table-column>
          <el-table-column prop='title' label='标题' align='center' />
          <el-table-column prop='companyName' label='委托商' align='center' />
          <el-table-column label='结算类型' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.type === 1 ? '委托商托运费用' : '委托商港口费用' }}
            </template>
          </el-table-column>
          <el-table-column prop='createTime' label='暂缓开票时间' align='center' />
          <el-table-column prop='suspendBillingPrice' label='暂缓开票金额' align='center' />
          <el-table-column prop='deductTime' label='使用暂缓开票时间' align='center' width='130px' />
          <el-table-column prop='statusStr' label='状态' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.status === 0 ? '未开票' : '已开票' }}
            </template>
          </el-table-column>
          <el-table-column label="推送状态" width="140" align="center" show-overflow-tooltip>
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>{{ scope.row.isSend==1?'已推送':'未推送' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="settINum" label="结算数量" width="140" align="center" show-overflow-tooltip />
          <el-table-column label='操作' width='210' align='center' fixed="right">
            <template slot-scope='scope'>
              <el-button size='mini' class='searchBtn' @click='detailsClick'>详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer' style='margin-top: 20px'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>
    <el-dialog title='详情' :visible.sync='DialogVisible'
               :width="activeName==='settlement' ? '1300px' :'700px'" center>
      <div class='detail'>
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>抵扣对账单</span>
          </div>
          <div class='operationTable'>
            <div style='padding: 0 23px'>
              <el-form :model='detailData' label-position='left'>
                <el-row>
                  <el-col :span='12'>
                    <el-form-item label='对账单编号:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='状态:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label='标题:'>
                  <span>{{ detailData.supplierName }}</span>
                </el-form-item>
                <el-form-item label='收付类型:'>
                  <span>{{ detailData.supplierName }}</span>
                </el-form-item>
                <el-form-item label='委托商:'>
                  <span>{{ detailData.supplierName }}</span>
                </el-form-item>
                <el-form-item label='结算类型:'>
                  <span>{{ detailData.supplierName }}</span>
                </el-form-item>
                <el-row>
                  <el-col :span='12'>
                    <el-form-item label='暂缓开票金额:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='剩余暂缓开票金额:'>
                      <span>{{ detailData.supplierName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label='对账单生成时间:'>
                  <span>{{ detailData.supplierName }}</span>
                </el-form-item>
                <el-form-item label='暂缓开票时间:'>
                  <span>{{ detailData.supplierName }}</span>
                </el-form-item>

              </el-form>
            </div>
          </div>

          <div class='operation'>
            <div class='operationTitle'>
              <div class='line' />
              <span>抵扣对账单</span>
            </div>
            <div class='operationTable'>
              <el-table :data='operationData' border>
                <el-table-column label='序号' align='center' width='50px' />
                <el-table-column label='对账单编号' align='center' width='160px' />
                <el-table-column prop='operateType' label='使用金额' align='center' />
                <el-table-column prop='operationName' label='使用时间' align='center' />
                <el-table-column prop='remark' label='状态' align='center' />
                <el-table-column prop='remark' label='操作人' align='center' />
                <el-table-column prop='remark' label='操作时间' align='center' />
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>


  </div>
</template>

<script>
  import {
    getOtherPageList,
  } from '@/service/basicfile';
  import {
    formatTime,
  } from '@/config/mUtils';
  import popup from '@/components/popup';
  import selectMap from '@/components/map';

  export default {
    components: {
      popup,
      selectMap,
    },

    data() {
      return {
        form: {
          companyName: '',
          title: '',
          status: '',
          page: 1,
          rows: 10,

        },
        total: 0,
        tableLoad: false,
        TableDatas: [
          // {warehouseName: '对账单编号'}
        ],
        detailData: {},
        activeName: 'Basics',
        DialogVisible: false,
        checkTableData: [],
        operationData: [],

        rules: {
          warehouseName: {
            required: true,
            message: '请输入委托商仓库名称',
            trigger: 'blur',
          },
          customer: {
            required: true,
            message: '请选择委托商',
            trigger: 'blur',
          },
          address: {
            required: true,
            message: '请输入地址',
            trigger: 'blur',
          },
        },
      };

    },
    filters: {
      createTimeFormat: function(value) {
        console.log(value);
        if (value) {
          return formatTime(value, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }


      },
    },
    mounted() {
      // this.getOtherPageList();
    },
    methods: {
      async getOtherPageList() {
        this.tableLoad = true;
        let res = await getOtherPageList(this.form);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;

      },
      compareDate(d1, d2) {
        return ((new Date(d1.replace(/-/g, '\/'))) > (new Date(d2.replace(/-/g, '\/'))));
      },
      // 结束时间
      dateChange(val) {
        if (this.form.createTimes[1] && this.form.createTimes[0] && this.compareDate(this.form.createTimes[0], this.form.createTimes[1])) {
          if (val == this.form.createTimes[1]) this.form.createTimes[1] = '';
          if (val == this.form.createTimes[0]) this.form.createTimes[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      searchBtn() {
        this.form.page = 1;
        this.getOtherPageList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.createTimes = ['', ''];
        this.form.page = 1;
        this.form.rows = 10;

      },
      tableIndexMethod(index) {
        return this.form.rows * (this.form.page - 1) + index + 1;
      },
      contractSizeChange(row) {
        this.form.rows = row;

      },
      contractCurrentChange(page) {
        this.form.page = page;

      },
      handleClick() {

      },
      //详情
      detailsClick() {
        this.DialogVisible = true;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .deferlnvoicing {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .content {

    }

    ::v-deep .detail {


      width: 100%;
      padding: 10px 0 20px 20px;

      .el-form-item {
        margin-bottom: 5px;
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }

      .settleInformation {
        .el-table th.is-leaf {
          border-bottom: 1px solid #EBEEF5;
          padding: 0;
        }
      }

    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 25px;
      margin-top: 35px;

      button {
        margin: 0 15px;
      }
    }

  }

  ::v-deep {

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      color: #606266;
    }


  }
</style>
